
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import {ModalHeader, ModalContent, ModalFooter,ContentItem,Dropdown} from '@gnb/components/Common'
import PreferenceContentTemplate from '@gnb/templates/PreferenceContentTemplate.vue'
import { mapActions } from 'vuex'
import * as types from '@gnb/store/types'
import MultiAccountModal from './Modals/MultiAccountModal.vue'
import api from '@gnb/api/common'

@Component({
    components:{MultiAccountModal,ModalHeader,ModalContent,ModalFooter,ContentItem,PreferenceContentTemplate,Dropdown}
    ,methods:{
        ...mapActions({
            download: types.DOWNLOAD_PC,
            loading: types.COMMON_LOADDING
        })
    }
})
export default class MultiAccountView extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({type:Array}) value!: gnb.multiMail[];

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    lastIndex: number = 0;
    multiList: Array<gnb.multiMail> = [];

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    
    @Watch('value')
    onChangeValue(){
        this.multiList = this.value;
        api.getMultiMailList().then((res)=>{
            this.multiList = res.map((mail)=>{
                mail.text = '';
                this.getUserInfo(mail.personCode).then((res)=>{
                    mail.text = res;
                });
                return mail;
            });
        });
        this.lastIndex = this.value.filter((multi: gnb.multiMail) => {
            return !multi.isDeleted;
        })?.length - 1;
        this.$emit('changeMultiList', this.value);
    }
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    async getUserInfo(personCode:string){
        return await api.getUserByPersonCode(personCode).then( (res)=>{
              return  res.deptName+'/'+res.displayName+'('+res.personCode+')'
          });
      }

    open(){
       this.$emit('open')
    }

    move(from: number, to: number) {
        this.$emit('move', from, to);
        this.multiList.splice(to, 0, this.multiList.splice(from, 1)[0]);
        return this.multiList;
    }

    edit(item: gnb.multiMail) {
        this.$emit('edit', item)
    }

    async deleteMulti(item: gnb.multiMail) {
        const message = '해당 멀티계정을 삭제하시겠습니까?';
        if (await(window as any).confirmAsync(message) == false) {
            return false;
        } else {
           item.isDeleted = true;
           this.$emit('delete', item)
        }
    }
   
   //
   // ────────────────────────────────────────────────────── I ──────────
   //   :::::: C R E A T E D : :  :   :    :     :        :          :
   // ────────────────────────────────────────────────────────────────
   //

    created(){
        this.onChangeValue();
    }
}